<template>
    <div>
        <b-card>
            <div class="card-text">
                <b-row align-v="end">
                    <b-col align-h="center" cols="12" md="6" lg="4">
                        <app-autocomplete
                            label="Cliente"
                            placeholder="Cliente"
                            :items="clients"
                            v-model="theClient"
                            required
                            @input="$v.filters.clientId.$touch()"
                            :error="$v.filters.clientId.$error"
                        />
                    </b-col>
                    <b-col align-h="center" cols="12" md="3" lg="3">
                        <app-date-picker
                            classes="ml-2"
                            :with-time="false"
                            label="Desde"
                            v-model="filters.from"
                            id="from"
                            required
                            @input="$v.filters.from.$touch()"
                            :error="$v.filters.from.$error"
                        />
                    </b-col>
                    <b-col align-h="center" cols="12" md="3" lg="3">
                        <app-date-picker
                            classes="ml-2"
                            :with-time="false"
                            label="Hasta"
                            v-model="filters.to"
                            id="to"
                        />
                    </b-col>
                    <b-col align-v="end" cols="auto">
                        <b-btn
                            variant="primary"
                            title="filtrar"
                            @click="onFilter"
                        >
                            <i class="fa fa-filter"></i>
                        </b-btn>
                        <b-btn
                            variant="secondary"
                            title="limpiar"
                            @click="clearFilters"
                        >
                            <i class="fa fa-times"></i>
                        </b-btn>
                    </b-col>
                </b-row>
            </div>
        </b-card>
    </div>
</template>
<script>
import Autocomplete from '../../../UI/Controls/AutocompleteV2/Autocomplete.vue'
import DatePicker from '../../../UI/Controls/DateTimePicker/DateTimePicker.vue'
import {
    required,
    email,
    numeric,
    minLength,
    maxLength,
} from 'vuelidate/lib/validators'
export default {
    components: {
        appDatePicker: DatePicker,
    },
    data() {
        return {
            clients: [],
            filters: {
                clientId: '',
                from: '',
                to: '',
            },
            theClient: '',
        }
    },
    watch: {
        theClient(val) {
            this.filters.clientId = val?.id
        },
    },
    validations: {
        filters: {
            clientId: { required },
            from: { required },
        },
    },
    methods: {
        onFilter() {
            this.$v.$touch()
            if (this.$v.$invalid)
                return toastr.error(
                    'Porfavor ingrese todos los campos obligatorios(*) para poder filtrar la información'
                )
            this.$emit('filters', this.filters)
        },
        async loadClients() {
            const { data } = await repo.get(
                'clients',
                null,
                'Lo sentimos, ha ocurrido un error'
            )
            this.clients = data
        },
        clearFilters() {
            this.theClient = ''
            Object.keys(this.filters).map((key) => (this.filters[key] = ''))
            this.$emit('clearFilters', this.filters)
        },
    },
    created() {
        this.loadClients()
    },
}
</script>
